/** @jsx h */
// @flow
import { h } from 'preact';
import { styled } from 'goober';
import Loader from './Loader';

type Props = {
  loaderText?: string,
};

const LoaderScreenContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  top: -16px;
  .loaderText {
    text-align: center;
    text-align: center;
    font-size: 20px;
    color: var(--primaryCTAColor);
    margin: 20px;
    font-weight: 600;
  }
`;

const LoaderScreen = (props: Props) => {
  return (
    <LoaderScreenContainer>
      <Loader />
      {props.loaderText && <div className='loaderText'>{props.loaderText}</div>}
    </LoaderScreenContainer>
  );
};

export default LoaderScreen;



// WEBPACK FOOTER //
// ./components/checkoutWidget/LoaderScreen.js